import { render, staticRenderFns } from "./StandardTimeSpanSelector.vue?vue&type=template&id=0a385265"
import script from "./StandardTimeSpanSelector.vue?vue&type=script&lang=js"
export * from "./StandardTimeSpanSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports